import React from "react";
import {SettingsRowValue} from "../../common/CustomTable/CustomTable";
import {useTranslation} from "react-i18next";
import Collapsable from "../../common/Collapsable/Collapsable";

function NlpServiceSettings(props) {
    const {t} = useTranslation(['thirdPartyService']);
    const {
        thirdPartyService,
        style,
        isDisabled
    } = props;

    return (
        <Collapsable label={t('thirdPartyService:label.nlpSettings')}
                           style={style} isDisabled={isDisabled}
        >
            <div className="settings-table">
                <div className="table-row-group">
                    <SettingsRowValue label={t('thirdPartyService:label.url')}
                                      value={thirdPartyService.url} isDisabled={isDisabled}/>
                    <SettingsRowValue label={t('thirdPartyService:label.feedsApiUrl')}
                                      value={thirdPartyService.feedsApiUrl} isDisabled={isDisabled}/>
                    <SettingsRowValue label={t('thirdPartyService:label.jobControlUrl')}
                                      value={thirdPartyService.jobControlUrl} isDisabled={isDisabled}/>

                </div>
            </div>
        </Collapsable>
    )
}

export default NlpServiceSettings;
